module.exports = "<div #trigger class=\"vq-infinite-scroll\">\n\tChargement de résultats supplémentaires...\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/vqutils/infinite-scroll/infinite-scroll.component.html
// module id = ./src/app/vqutils/infinite-scroll/infinite-scroll.component.html
// module chunks = main